import { gql } from "@/__generated__/gql";

export const HIDDEN_ACTIONS_COUNT = gql(`
  query HiddenActionsCount(
    $date: Date!
    $orgId: ID!, 
    $userId: ID!
    ) {
    node(id: $userId) {
      ... on User {
      id
      actions(
        date: $date
        organizationId: $orgId
        filter: HIDDEN
      ) {
        totalCount
      }
    }
  }
}
`);
